import { PageType } from '@ts-tutor-landing/enums'

import { useCommonStore } from '@stores/common'

export default defineNuxtRouteMiddleware( async () => {
  const commonStore = useCommonStore()
  commonStore.setPageType(PageType.Math)
})
